//Altezza minima in pixel di ogni minuto
export const MINUNTE_HEIGHT = 3;
//Numero di ore in ogni giornata
export const HOUR_COUNT = 15;
//Orario di inizio degli slot (9 del mattino)
export const DAY_START_HOUR = 7;
//Valore orario di inizio degli slot (9 del mattino)
export const DAY_START_VALUE = DAY_START_HOUR * 60;
//Larghezza di ogni room
export const ROOM_WIDTH = 200
//Altezza dell'header di ogni room
export const SR_HEADER_HEIGHT = 3 * 16;
//Spazio tra uno slot e l'altro
export const SLOT_RIGHT_PADDING = 0;
